"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var url_parse_1 = __importDefault(require("url-parse"));
var crypto_js_1 = __importDefault(require("crypto-js"));
/**
 * Return the headers needed to issue an API request
 * @param key The API key
 * @param secret The API secret
 * @param method The HTTP method
 * @param url The API URL
 * @param The timestamp (UNIX ms)
 * @param The name of the timestamp header
 * @return The necessary headers
 */
function getHeaders(key, secret, method, url, timestamp, tHeader) {
    var _a;
    if (tHeader === void 0) { tHeader = 'X-ROCK-TIMESTAMP'; }
    var endpoint = new url_parse_1.default(url).pathname;
    var concat = "" + method + endpoint + timestamp;
    var signature = crypto_js_1.default.HmacSHA1(concat.toLowerCase(), secret).toString(crypto_js_1.default.enc.Hex);
    return _a = {},
        _a[tHeader] = timestamp,
        _a.Authorization = key + ":" + signature,
        _a['Content-Type'] = 'application/json',
        _a;
}
exports.getHeaders = getHeaders;
/**
 * Generate JSON object for API calls
 * @param key The API key
 * @param secret The API secret
 * @param method The HTTP method
 * @param endpoint The API endpoint
 * @param body The data (if needed)
 * @return An object containing all the settings
 */
function getAPISettings(key, secret, method, url, body, responseType, timeout) {
    if (body === void 0) { body = {}; }
    if (responseType === void 0) { responseType = 'json'; }
    if (timeout === void 0) { timeout = 45000; }
    return {
        timeout: timeout,
        body: body,
        url: url,
        responseType: responseType,
        method: method.toUpperCase(),
        headers: getHeaders(key, secret, method, url, new Date().getTime()),
    };
}
exports.getAPISettings = getAPISettings;
//# sourceMappingURL=api.js.map